module.exports = __webpack_public_path__ + "static/media/loading-blue.41ba60ae.gif";